export default {"src":"https://cdn.tanzhi.cn/_next/static/media/hierarchy.9a558fd4.svg","height":51,"width":52,"blurWidth":0,"blurHeight":0};